import { useEffect, useRef } from "react";
import { Field } from "react-final-form";
import { useSelector } from "react-redux";

import { FormField, IPickerListItem, Input, Picker, SpacingToken } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { TeamPickerListItem, TeamPickerSelectedListItem } from "components/picker-items/teamPickerItems";
import { ITeam, selectTeamsAlphabetically } from "store/entities/teams";
import { withVar } from "themes/helpers";

export const General: React.FC = () => {
  const inputRef = useRef<HTMLInputElement>(null);
  const teams = useSelector(selectTeamsAlphabetically);
  const handleTeamSelect = (
    input: { onChange: (value: string) => void },
    selectedOptions: IPickerListItem[] | null
  ): void => {
    if (selectedOptions && selectedOptions.length) {
      input.onChange(selectedOptions[0].key);
    }
  };

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const teamOptions: IPickerListItem[] = teams.map((team: ITeam) => ({
    key: team.id,
    name: team.name,

    customElement: {
      selectedItemBody: <TeamPickerSelectedListItem name={team.name} isDefault={team.isDefault} pickerType="single" />,
      listItemBody: <TeamPickerListItem name={team.name} isDefault={team.isDefault} pickerType="single" />,
    },
  }));

  return (
    <Flex column padding={`${withVar(SpacingToken.Spacing12)} ${withVar(SpacingToken.Spacing16)}`} alignItems="center">
      <Field<string> name="name" label="Name">
        {({ input, meta }) => (
          <FormField labelText="Contact form name" error={meta.touched && meta.error} css={inputStyles}>
            <Input
              {...input}
              ref={inputRef}
              value={input.value}
              data-1p-ignore
              data-testid="contact-form-name-input"
              placeholder="Enter contact form name..."
              onChange={event => input.onChange(event.target.value)}
              autoComplete="off"
              error={meta.error && meta.touched}
            />
          </FormField>
        )}
      </Field>
      <Field name="teamID">
        {({ input }) => {
          const selectedTeamOptions = teamOptions.filter(({ key }): boolean => key === input.value);
          return (
            <FormField labelText="Assign tickets from this form to team" css={inputStyles}>
              <Picker
                options={teamOptions}
                selected={selectedTeamOptions}
                onSelect={(selectedOptions: IPickerListItem[] | null) => handleTeamSelect(input, selectedOptions)}
                maxListHeight={200}
                hideClearButton
              />
            </FormField>
          );
        }}
      </Field>
    </Flex>
  );
};

const inputStyles = { maxWidth: "482px", width: "100%" };
